import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetCategories = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/categories/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load categories.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateCategory = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/categories/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create category.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateCategory = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/categories/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update category.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteCategory = async (id: number): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/categories/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete category.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
